<section id="awards" class="pb-0">
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="row align-items-center mb-6" 
             data-anime='{ "opacity": [0,1], "duration": 600, "delay": 0, "staggervalue": 300, "easing": "easeOutQuad" }'>
          <div class="col-10">
            <span class="text-base-color fw-700 text-uppercase fs-14 ls-05px">Our Benefits</span>
          </div>
          <div class="col-2 text-end">
            <span class="text-base-color fs-14 fw-700">03</span>
          </div>
          <div class="col-12 mt-5px">
            <div class="separator-line-2px w-100 d-block bg-base-color"></div>
          </div>
        </div>
        <div class="row">
          <div class="col-xl-4 col-lg-5 last-paragraph-no-margin md-mb-30px" 
               data-anime='{ "el": "childs", "translateY": [30, 0], "opacity": [0,1], "duration": 600, "delay": 0, "staggervalue": 300, "easing": "easeOutQuad" }'>
            <h4 class="fw-700 ls-minus-1px mb-20px">Smart, affordable and customized house planning for every family.</h4>
            <p class="w-85 lg-w-100 text-justify">We create modern, vastu-friendly, and budget-optimized home designs tailored to your lifestyle. From concept to complete house plans, we ensure clarity, accuracy, and perfect space utilization.</p>
          </div>
          <div class="col-xl-8 col-lg-7" 
               data-anime='{ "el": "childs", "translateY": [30, 0], "opacity": [0,1], "duration": 600, "delay": 0, "staggervalue": 300, "easing": "easeOutQuad" }'>
            <div class="row g-0">
              <div class="col-2 text-center align-self-center">
                <span class="text-dark-gray fs-14 fw-600">9X</span>
              </div>
              <div class="col-8 last-paragraph-no-margin ps-30px pe-30px pt-15px pb-15px border-start border-color-light-medium-gray">
                <p>Site of the day - <span class="fw-600 text-dark-gray">Awards</span></p>
              </div>
              <div class="col-2 align-self-center text-center">
                <span class="text-dark-gray fs-14 fw-600">2021</span>
              </div>
            </div>
            <div class="row border-top border-color-light-medium-gray g-0">
              <div class="col-2 text-center align-self-center">
                <span class="text-dark-gray fs-14 fw-600">2X</span>
              </div>
              <div class="col-8 last-paragraph-no-margin ps-30px pe-30px pt-15px pb-15px border-start border-color-light-medium-gray">
                <p>Site of the year - <span class="fw-600 text-dark-gray">CSS Design Awards</span></p>
              </div>
              <div class="col-2 align-self-center text-center">
                <span class="text-dark-gray fs-14 fw-600">2020</span>
              </div>
            </div>
            <div class="row border-top border-color-light-medium-gray g-0">
              <div class="col-2 text-center align-self-center">
                <span class="text-dark-gray fs-14 fw-600">4X</span>
              </div>
              <div class="col-8 last-paragraph-no-margin ps-30px pe-30px pt-15px pb-15px border-start border-color-light-medium-gray">
                <p>Site of the month - <span class="fw-600 text-dark-gray">Awards</span></p>
              </div>
              <div class="col-2 align-self-center text-center">
                <span class="text-dark-gray fs-14 fw-600">2019</span>
              </div>
            </div>
            <div class="row border-top g-0">
              <div class="col-2 text-center align-self-center">
                <span class="text-dark-gray fs-14 fw-600">3X</span>
              </div>
              <div class="col-8 last-paragraph-no-margin ps-30px pe-30px pt-15px pb-15px border-start border-color-light-medium-gray">
                <p>Site of the year - <span class="fw-600 text-dark-gray">The portfolio</span></p>
              </div>
              <div class="col-2 align-self-center text-center">
                <span class="text-dark-gray fs-14 fw-600">2018</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

